module.exports = __webpack_public_path__ + "static/media/logo-3x.3b06e6c8.png";